import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { SiOpenai } from "react-icons/si";
import NodeWrapper from "./NodeWrapper";

const OpenaiNode = memo(({ id, data, isConnectable, selected }) => (
  <NodeWrapper
    id={id}
    data={data}
    icon={<SiOpenai size={18} />}
    title="OpenAI"
    color="#10A37F"
    bgColor="#F0FFF8"
    isConnectable={isConnectable}
    selected={selected}
  >
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 600,
        backgroundColor: "#E0F2F1",
        color: "#10A37F",
        border: "1px solid #10A37F30",
      }}
    >
      <SiOpenai size={12} color="#10A37F" />
      GPT AI Assistant
    </div>

    {data?.prompt && (
      <div
        style={{
          fontSize: 10,
          color: "#555",
          marginTop: 6,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          maxWidth: 190,
          lineHeight: 1.4,
        }}
      >
        {data.prompt}
      </div>
    )}
  </NodeWrapper>
));

OpenaiNode.displayName = "OpenaiNode";
export default OpenaiNode;
